<template>
  <h1>
    API
  </h1>
  <p>
    Use power of the rpgRoot API to develop your own game - any game!
  </p>
  Choose which parts of API you want to use:
  <p>
  <ul>
    <li>- World settings</li>
    <li>- Gameplay features like: shoping, equipment, battle etc.</li>
  </ul>
  </p>
  <p>Open API specyfication - comming soon.</p>
  To discuss any details: features or pricing offer, please contact us with <a href="mailto:api@rpgroot.com">api@rpgroot.com</a>
  <p>Available soon.</p>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  components: {}
})
export default class Api extends Vue {}
</script>

<style scoped>
ul {
  list-style: none;
}
</style>
